import { Box, Stack } from "@mui/material";
import ContactFormDsfr from "components/ContactFormDsfr";
import DSFRListContext from "components/DSFRListContext";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const Help = (props) => {
  const { page } = props;
  const { title, contents, template } = page;
  const { subtitle, thematicTitle, thematicTilesList, faqTitle, faqSubtitle, faqCardsList } = contents;

  const dsfrListContextValue = useMemo(() => ({ xs: 12, sm: 12, lg: 4 }), []);

  const bo = useMemo(() => typeof subtitle === "object", [subtitle]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack>
          <h1>{title}</h1>
          {subtitle && <p className="fr-text--xl">{subtitle}</p>}
        </Stack>
      </TemplateBanner>
      <DSFRListContext.Provider value={dsfrListContextValue}>
        <Box sx={{ px: { xs: 2, lg: 0 } }}>
          <Wrapper className="fr-mt-5w fr-mb-12v">
            <h2>{thematicTitle}</h2>
            {thematicTilesList}
          </Wrapper>
        </Box>
        <Box sx={{ bgcolor: "var(--background-contrast-grey)" }}>
          <Wrapper className="fr-my-5w" sx={{ px: { xs: 2, lg: 0 } }}>
            <h2>{faqTitle}</h2>
            <p className="fr-text--xl fr-text--bold">{faqSubtitle}</p>
            {faqCardsList}
          </Wrapper>
        </Box>
      </DSFRListContext.Provider>
      <ContactFormDsfr page={page} />
      <HelpAndShare alwaysDisplayShare template={template} />
    </>
  );
};

Help.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default Help;
